export const STOPWATCH_STORAGE_KEY = "lexmom-stopwatch-session";
export const STOPWATCH_SYNC_EVENT = "lexmom-stopwatch-session-updated";

export const formatStopwatchSeconds = (totalSeconds = 0) => {
  const safeSeconds = Math.max(0, Number(totalSeconds) || 0);
  const hrs = String(Math.floor(safeSeconds / 3600)).padStart(2, "0");
  const mins = String(Math.floor((safeSeconds % 3600) / 60)).padStart(2, "0");
  const secs = String(safeSeconds % 60).padStart(2, "0");

  return `${hrs}:${mins}:${secs}`;
};

const notifyStopwatchChange = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(STOPWATCH_SYNC_EVENT));
};

const safeParse = (value) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

export const readStopwatchSession = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const parsed = safeParse(window.localStorage.getItem(STOPWATCH_STORAGE_KEY));

  if (!parsed?.startedAtMs) {
    return null;
  }

  return parsed;
};

export const writeStopwatchSession = (session) => {
  if (typeof window === "undefined") {
    return session;
  }

  window.localStorage.setItem(STOPWATCH_STORAGE_KEY, JSON.stringify(session));
  notifyStopwatchChange();
  return session;
};

export const clearStopwatchSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(STOPWATCH_STORAGE_KEY);
  notifyStopwatchChange();
};

export const createRunningStopwatchSession = (startedAtMs = Date.now()) => ({
  startedAtMs,
});

export const getStopwatchElapsedSeconds = (
  session,
  nowMs = Date.now(),
) => {
  if (!session?.startedAtMs) {
    return 0;
  }

  return Math.max(0, Math.floor((nowMs - session.startedAtMs) / 1000));
};
